export default __webpack_public_path__ + "static/media/FinanZero_relatorio_construcao.942f4263.png";